export const settings = {
  setShareTitle: 'Dalintis programėle',
  setNotifiationsTitle: 'Pranešimai',
  setContactAppOwnerTitle: 'Susisiekti su programėlės savininku',
  setContactDevelopersTitle: 'Susisiekti su kūrėjais',
  setReportAppTitle: 'Pranešti apie programėlę',
  setDeleteAccountTitle: 'Ištrinti paskyrą',
  setLogOutTitle: 'Atsijungti',
  setShareAppCurtainTitle: 'Dalintis programėle',
  setShareAppCurtainButtonTitle: 'Kopijuoti nuorodą',
  setShareAppAlertWhenAppLinkWasCopied: 'Nuoroda nukopijuota!',
  setNotificationsInAppTitle: 'Programėlėje',
  setNotificationsPushContent: 'Push pranešimai',
  setNotificationsChatsTitle: 'Pokalbiai',
  setNotificationsDiscussionsTitle: 'Diskusijos',
  setNotificationsNewsTitle: 'Naujienų srautas',
  setNotificationsEventsTitle: 'Renginiai',
  setNotificationsAdminTitle: 'Administratoriaus žinutės',
  setNotificationsBlogTitle: 'Tinklaraštis',
  setNotificationsPushOffContent: 'Push pranešimai išjungti',
  setNotificationsPushOffText: 'Norėdami įjungti push pranešimus, eikite į savo įrenginio nustatymus ir leiskite pranešimus',
  setReportAppFlagCurtainTitle: 'Pažymėti',
  setAppReportedCurtainContent: 'Turinys pažymėtas',
  setDeleteCurtainTitle: 'Ištrinti paskyrą',
  setDeleteCurtainInputContent: 'Slaptažodis',
  setDeleteCurtainCancelButtonTitle: 'Atšaukti',
  setDeleteCurtainConfirmButtonTitle: 'Patvirtinti',
  setDeleteCurtainIncorrectPasswordAlertText: 'Slaptažodis neteisingas',
  setTurnNotificationsOnText: 'Norėdami įjungti, paspauskite mygtuką žemiau ir leiskite gauti pranešimus.',
  setTurnNotificationsOnButton: 'Įjungti push pranešimus',
  changeLanguage: 'Keisti programėlės kalbą',
  changeLanguageAlertSuccess: 'Programėlės kalba sėkmingai pakeista'
}
